import moment from "moment";

export const getEstimatedFare = function (cat_id, Est_Fare_List) {
  if (Est_Fare_List) {
    const fare = Est_Fare_List[cat_id]?.trip_pay_amount;
    return fare;
  }
};

/**
 * Redirects to a specified URL with a given target.
 *
 * @param {string} url - The URL to navigate to.
 * @param {string} [target="_blank"] - The target where the URL will open. Possible values:
 *   - "_blank" (default): Opens in a new tab or window.
 *   - "_self": Opens in the same window or tab.
 *   - "_parent": Opens in the parent frame.
 *   - "_top": Opens in the full body of the window.
 */

export const handleRedirectUrl = (url, target = "_blank") => {
  const a = document.createElement("a");
  a.href = url;
  a.target = target;
  a.click();
};

export const getFormattedDateTime = () =>
  moment().format("YYYY-MM-DD HH:mm:ss");

export const getFormattedTime = (date) =>
  moment(date).format("HH:mm A");

export const removeSpaces = (text) => {
  return text.replace(/\s+/g, ""); // Removes all spaces
};

export const statusValues = {
  request: "Request",
  assigned: "Partner Assigned",
  accept: "Partner Accepted",
  arrive: "Partner Arrived",
  begin: "Begin",
  completed: "Completed",
  cancel: "Cancelled",
  p_cancel_pickup: "Partner Cancel at Pickup Location",
  p_cancel_drop: "Partner Cancel at Drop Location",
  expired: "Expired",
  paid_cancel: "Cancelled",
};

export const statusValuesColor = {
  request: "darkred",
  assigned: "darkred",
  accept: "darkred",
  arrive: "darkred",
  begin: "darkred",
  completed: "green",
  cancel: "darkred",
  p_cancel_pickup: "darkred",
  p_cancel_drop: "darkred",
  expired: "darkred",
  paid_cancel: "darkred",
};

export const paymentOptionDisabled = ['card','Card','wallet','Wallet','stripe','Stripe']

export const extractSuggestionProps = (getSuggestionItemProps) => {
  const { key, ...restProps } = getSuggestionItemProps; // Destructure and remove key
  return restProps;
};